// extracted by mini-css-extract-plugin
module.exports = {"stage":"Stage_stage__2FiJT","quantity":"Stage_quantity__24jz7","label":"Stage_label__JrmM1"};